import { locationType, selectItemType } from '@src/types';

export type memberInfoFormType = {
  firstName: string;
  lastName: string;
  gender: selectItemType | null;
  address: locationType | null;
  dob: Date | string | null;
  memberIdNumber: string;
  phone: string;
};

export const memberInfoFormValues: memberInfoFormType = {
  firstName: '',
  lastName: '',
  gender: null,
  dob: '',
  memberIdNumber: '',
  address: null,
  phone: '',
};

export const maskedInputs = ['phone'];

export const selectFields = ['gender'];

export const objectFields = ['address'];
